"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var _1 = require(".");
var Thumbprint_png_1 = __importDefault(require("../assets/svgs/Thumbprint.png"));
var StepCard = function (_a) {
    var steps = _a.steps, currentStep = _a.currentStep;
    var percentage = (currentStep / steps.length) * 100;
    return ((0, jsx_runtime_1.jsxs)(_1.Card, __assign({ sx: {
            backgroundColor: 'primary.main',
            display: 'flex',
            height: '100%',
            position: 'relative',
        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    opacity: '0.3',
                    backgroundImage: "url(".concat(Thumbprint_png_1.default, ") "),
                } }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(90deg, #5029EF 8.78%, rgba(25, 25, 51, 0) 100%)',
                } }), (0, jsx_runtime_1.jsx)(_1.CardHeader, { sx: { zIndex: 8, paddingBottom: '2.0rem' }, title: (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "bodyXLarge", sx: { color: 'common.white', fontWeight: 'bold' } }, { children: ["Your account setup is ", percentage, "% complete"] })) }), (0, jsx_runtime_1.jsx)(_1.CardContent, __assign({ sx: {
                    zIndex: 8,
                } }, { children: (0, jsx_runtime_1.jsx)(_1.VerticalStepper, { steps: steps, currentStep: currentStep }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: { marginX: '-2.8rem', marginTop: '-5.5rem' } }, { children: (0, jsx_runtime_1.jsx)(_1.ProgressBar, { completedPercentage: percentage }) }))] })));
};
exports.StepCard = StepCard;
